export const ORDER_STATUS_LABELS = {
    placed: "Chờ xác nhận",
    confirmed: "Chờ làm món",
    preparing: "Đang làm món",
    served: "Sẵn sàng giao",
    completed: "Thành công",
    cancelled: "Đơn hủy",
} as const;

export type OrderStatusKey = keyof typeof ORDER_STATUS_LABELS;

export const ORDER_TYPE_LABELS = {
    dine_in: "Tại quán",
    takeaway: "Mang đi",
} as const;

export type OrderTypeKey = keyof typeof ORDER_TYPE_LABELS;

export const ORDER_RECEIVING_PLACE_LABELS = {
    1: "Nhận món tại quầy",
    2: "Nhận món tại bàn",
} as const;

export type OrderReceivingPlaceKey = keyof typeof ORDER_RECEIVING_PLACE_LABELS;

export const getOrderStatusLabel = (status?: string | null) =>
    status ? ORDER_STATUS_LABELS[status as OrderStatusKey] ?? status : "-";

export const getOrderTypeLabel = (orderType?: string | null) =>
    orderType ? ORDER_TYPE_LABELS[orderType as OrderTypeKey] ?? orderType : "-";

export const getOrderReceivingPlaceLabel = (receivingPlace?: number | string | null) => {
    if (receivingPlace === undefined || receivingPlace === null || receivingPlace === "") {
        return "-";
    }
    const key = Number(receivingPlace);
    return ORDER_RECEIVING_PLACE_LABELS[key as OrderReceivingPlaceKey] ?? String(receivingPlace);
};

export const getOrderStatusClassName = (status?: string | null) => {
    if (!status) return "text-muted";
    switch (status) {
        case "placed":
            return "text-secondary";
        case "confirmed":
            return "text-warning";
        case "preparing":
            return "text-primary";
        case "served":
            return "text-info";
        case "completed":
            return "text-success";
        case "cancelled":
            return "text-danger";
        default:
            return "text-muted";
    }
};
